import React from 'react';
import {StyledFieldset, StyledLegend} from './styles';

const Fieldset = ({children, legend}) => (
  <StyledFieldset>
    <StyledLegend>
      {legend}
    </StyledLegend>
    
    {children}
  </StyledFieldset>
);

export default Fieldset;